import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { HttpClient } from '@angular/common/http';
import { FeatureService } from '../../../services/feature.service';


/**
 * Custom Feature: Displays a customer-branded banner.
 * HTML (BrandBanner.html) and CSS (BrandBanner.css) files are fetched from 
 * the customer's custom assets location.
 */
@Component({
	selector: 'brand-banner',
	templateUrl: './brand-banner.component.html',
	styleUrl: './brand-banner.component.css'
})
export class BrandBannerComponent implements OnInit {

	htmlContent: SafeHtml = '';
	custId: string = '';
	featureId: string = 'BrandBanner';

	constructor(
		private http: HttpClient, 
		private sanitizer: DomSanitizer,
		private featureService: FeatureService
	) { }

	ngOnInit(): void {
		this.custId = this.featureService.getCustomerId();
		this.loadBannerAssets();
	}
	
	private loadBannerAssets(): void {
		const cssHref = `/app/aw-ui-angular/assets/custom/${this.custId}/css/${this.featureId}.css`;

		if (!document.querySelector(`link[href="${cssHref}"]`)) {
			const link = document.createElement('link');
			link.rel = 'stylesheet';
			link.href = cssHref;
			document.head.appendChild(link);
		}
		
		const htmlHref = `/app/aw-ui-angular/assets/custom/${this.custId}/html/${this.featureId}.html`;

		this.http.get(htmlHref, { responseType: 'text' }).subscribe({
			next: (data) => this.htmlContent = this.sanitizer.bypassSecurityTrustHtml(data),
			error: (err) => console.error('Failed to load banner HTML', err)
		});		
	}
}
